import { useRef, useEffect } from "react";
import { Input } from "@components";
import { Search } from "react-bootstrap-icons";

export default function ProfileAccountsTable({
  accounts,
  loading,
  searchTerm,
  onSearchChange,
  hasMoreData,
  onLoadMore,
}) {
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (!hasMoreData || !sentinelRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) onLoadMore?.();
      },
      { rootMargin: "200px" },
    );

    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [hasMoreData, onLoadMore, accounts.length]);

  return (
    <div className="mt-8">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold text-zinc-900">Accounts</h3>
          <p className="text-xs italic text-zinc-500 mt-1">
            Accounts with this profile applied
          </p>
        </div>
        <div className="relative w-48">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400 size-3.5 z-10" />
          <Input
            type="text"
            placeholder="Search accounts"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-9 py-1.5 text-sm"
          />
        </div>
      </div>
      <div className="mt-4 rounded-3xl bg-white shadow-[4px_4px_16px_0px_rgba(0,0,0,0.16)] overflow-hidden px-4 py-4">
        {loading ? (
          <p className="py-6 text-center text-sm text-zinc-400">Loading...</p>
        ) : accounts.length === 0 ? (
          <p className="py-6 text-center text-sm text-zinc-400">
            {searchTerm?.trim()
              ? "No matching accounts"
              : "No accounts assigned to this profile"}
          </p>
        ) : (
          <table className="w-full">
            <tbody>
              {accounts.map((c) => (
                <tr key={c.id}>
                  <td
                    className="px-3 py-4 text-zinc-500"
                    style={{ fontSize: 14, width: 120 }}
                  >
                    {c.accountCode}
                  </td>
                  <td
                    className="px-3 py-4 text-zinc-900"
                    style={{ fontSize: 14 }}
                  >
                    {c.name}
                  </td>
                </tr>
              ))}
              {hasMoreData && (
                <tr ref={sentinelRef}>
                  <td
                    colSpan={2}
                    className="py-4 text-center text-sm text-zinc-400"
                  >
                    Loading more…
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
